import { useTranslation } from "react-i18next";
import WhatsappCta from "./whatsapp-cta";
import PatternLayer from "./pattern-layer";

// Call-to-action for a general request without a specific tour/place.
export default function RequestCta() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden w-full rounded-2xl border border-kj-line bg-kj-card p-6 sm:p-10 flex flex-col items-start gap-5 sm:flex-row sm:items-center sm:justify-between">
      <PatternLayer kind="seigaiha" />
      <div className="relative">
        <h3 className="text-xl sm:text-2xl font-extrabold uppercase tracking-tight text-kj-ink">
          {t("activities.ctaTitle")}
        </h3>
        <p className="mt-2 text-base text-kj-sub max-w-xl leading-relaxed">
          {t("activities.ctaText")}
        </p>
      </div>
      <WhatsappCta
        label={t("activities.ctaButton")}
        withIcon
        className="relative w-full sm:w-auto shrink-0 bg-kj-gold text-kj-dark hover:bg-kj-gold/90 uppercase tracking-[0.08em] text-sm font-bold rounded-sm"
      />
    </section>
  );
}
